import { RMUpdateReviewSettingsSchema } from '@brightlocal/api-client';
import { RmReviewIdSchema, RmReviewStatusSchema } from '@brightlocal/shared';

import type { ReviewStatusChange } from '../types';

/** A status change as a mutation holds it: the review, the Update Review body and the status the review had. */
const ReviewStatusChangeSchema = RMUpdateReviewSettingsSchema.extend({
  reviewId: RmReviewIdSchema,
  previousStatus: RmReviewStatusSchema
});

/**
 * Whether a value is a status change: TanStack Query hands mutation variables back as `unknown`.
 * @param variables - The variables a status change mutation was sent with.
 */
export const isReviewStatusChange = (variables: unknown): variables is ReviewStatusChange =>
  ReviewStatusChangeSchema.safeParse(variables).success;
